import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const WriteVariablesIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M7.19999 11.4004L10.2 14.4004L7.19999 17.4004M2.99999 7.80039H21M4.79999 21.6004C3.47451 21.6004 2.39999 20.5259 2.39999 19.2004V4.80039C2.39999 3.47491 3.47451 2.40039 4.79999 2.40039H19.2C20.5255 2.40039 21.6 3.47491 21.6 4.80039V19.2004C21.6 20.5259 20.5255 21.6004 19.2 21.6004H4.79999Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

WriteVariablesIcon.displayName = 'WriteVariablesIcon';
